import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
export const Header = () => {
  return <header className="w-full border-b border-slate-800 px-6 py-4 md:px-12 md:py-6" data-id="element-54">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-55">
        <Link to="/" className="flex items-center gap-4" data-id="element-56">
          <Logo data-id="element-57" />
          <span className="text-2xl tracking-[0.2em] font-light text-zinc-300 font-['Orbitron']" data-id="element-58">
            SCION
          </span>
        </Link>
        <button className="px-4 py-2 border border-slate-700 rounded text-sm tracking-wider hover:bg-slate-900 transition-colors" data-id="element-59">
          Request Consultation
        </button>
      </div>
    </header>;
};